import React, { Component } from "react";
import { Input, message, Spin } from "antd";
import { ButtonItem, ErrorItem, Form, FormItem, InputItem, SwitchItem, } from "../../../../Components/Items";
import axios from "axios";
import { connect } from "react-redux";


class PowerBiConfiguracion extends Component {
  formRef = React.createRef();
  state = {
    archivo: null,
    loading: false,
    habilitado: false,
    desactivarEdicion: false,
  };

  componentDidMount() {
    this.consultarConfiguracion();
  }

  onFinish(values) {
    axios
      .post(
        "empresas/editarConfiguracionPowerBi",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Se ha modificado la configuracion de la empresa");
          this.consultarConfiguracion();
        } else if (res.data.success === 1) {
          message.error("No se pudo modificar la configuracion");
        } else {
          message.error("Hubo un error y no se modifico la configuracion");
        }
      });
  }

  async consultarConfiguracion() {
    this.setState({ loading: true })
    await axios
      .post(
        "empresas/selectConfiguracionPowerBi",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        console.log(res.data)
        if (res.data.status === 404) {
          message.error("Error no se encontro configuracion de esta empresa");
        } else {
          this.formRef.current.setFieldsValue({
            ...res.data
          });
          if (res.data.usuarioPowerbi && res.data.contrasenaPowerbi) {
            this.setState({ desactivarEdicion: true });
          }
          this.setState({ habilitado: res.data.correo })
        }
      });
    this.setState({ loading: false })
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }



  render() {
    return (
      <>
        <Spin spinning={this.state.loading}>
          <Form
            name="PowerBiConfiguracion"
            layout
            onFinish={this.onFinish.bind(this)}
            onFinishFailed={this.onFinishFailed}
            ref={this.formRef}
            loading={this.state.loading}
            onValuesChange={this.onValuesChange}
          >

            <FormItem
              label="Usuario Power Bi"
              name="usuarioPowerbi"
              pattern
              margin
            >
              <InputItem disabled={this.state.desactivarEdicion} />
            </FormItem>

           <FormItem
              label="Contraseña Power Bi"
              name="contrasenaPowerbi"
              margin
              rules={[
                { required: true, message: "La contraseña es obligatoria" },
                {
                  validator: (_, value) => {
                    if (!value) return Promise.resolve();

                    const lengthOk = value.length >= 8;
                    const hasUpper = /[A-Z]/.test(value);
                    const hasLower = /[a-z]/.test(value);
                    const hasDigit = /[0-9]/.test(value);
                    const hasSymbol = /[^A-Za-z0-9]/.test(value);

                    const groups = [hasUpper, hasLower, hasDigit, hasSymbol].filter(Boolean)
                      .length;

                    if (lengthOk && groups >= 3) {
                      return Promise.resolve();
                    }

                    return Promise.reject(
                      new Error(
                        "Mínimo 8 caracteres y usar al menos 3 de: mayúsculas, minúsculas, números y símbolos."
                      )
                    );
                  },
                },
              ]}
            >
              <Input.Password disabled={this.state.desactivarEdicion} />
            </FormItem>

            <FormItem
              label="Agregar a usuario actual"
              name="agregarAUsuarioActual"
              margin
              initialValue={false}
              valuePropName="checked"
            >
              <SwitchItem disabled={this.state.desactivarEdicion} />
            </FormItem>

            {!this.state.desactivarEdicion ?
            <ButtonItem
              type="primary"
              htmlType="submit"
              style={{ display: "block", margin: "0 0 0 auto" }}
            >
              Guardar Configuracion
            </ButtonItem> : null}
          </Form>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(PowerBiConfiguracion);
